export default __webpack_public_path__ + "static/canstar-2021-6fd9b5597b3725ade0b9c6d62e4ac372.png";